import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, List, Modal, Form, DatePicker, Icon} from 'antd';
import * as moment from 'moment';
import Document from './InlineDocument';

const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;

import {
    fetchContractorPreferences,
    fetchContractorQualifications,
    storeContractorQualification,
    updateContractorQualification,
    uploadQualificationDocument,
    deleteQualificationDocument
} from '../../actions';

class BusinessQualificationForm extends Component {
    render() {
        const { visible, onCancel, onCreate, form, title, confirmLoading, record} = this.props;
        const { getFieldDecorator } = form;

        const getDateValue = field => {
            field = record && record[field];
            return field ? moment(field, 'YYYY-MM-DD') : moment();
        };
        return (
            <Modal
                title={title}
                visible={visible}
                confirmLoading={confirmLoading}
                onOk={onCreate}
                onCancel={onCancel}
            >
                <Form layout="vertical">
                    <FormItem
                        label="Valid Through"
                    >
                        {getFieldDecorator('range', {
                            initialValue: [getDateValue('start_date'), getDateValue('end_date')],
                            rules: [{ type: 'array', required: true, message: 'Please select date!' }],
                        })(
                            <RangePicker format='DD/MM/YYYY' style={{width: '100%'}} placeholder={['Select Start Date', 'Select Expiry Date']}/>
                        )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
}
const WrappedForm = Form.create()(BusinessQualificationForm);


class BusinessQualification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: '',
            modalOpen: false,
            confirmLoading: false
        }
    }
    componentDidMount() {
        const {
            fetchContractorPreferences,
            fetchContractorQualifications,
            contractor
        } = this.props;
        fetchContractorPreferences(contractor);
        fetchContractorQualifications(contractor)
    }
    render() {
        const {data, isFetching} = this.props.preferences;
        const {data: qualifications} = this.props.qualifications;
        const {
            contractor,
            storeContractorQualification,
            updateContractorQualification,
            uploadQualificationDocument,
            deleteQualificationDocument,
        } = this.props;
        const {selected, modalOpen, confirmLoading} = this.state;

        const preference = data.find(i => i.name === 'Business Qualifications');
        const availableOptions = preference ? preference.options.filter(o => {
            return !!preference.config.options.find(i => i.option_id === o.id);
        }) : [];
        const handleCancel = () => {
            const form = this.formRef.props.form;
            form.resetFields();
            this.setState({modalOpen: false});
        };
        const openModal = item => (e) => {
            e.preventDefault();
            this.setState({modalOpen: true, selected: item});
        };
        const handleOk = () => {
            const form = this.formRef.props.form;
            const existing = qualifications.find(i => i.name === selected);
            const fn =  existing ? updateContractorQualification : storeContractorQualification;
            this.setState({
                confirmLoading: true
            });
            form.validateFields((err, values) => {
                if (err) {
                    return;
                }
                const [start_date, end_date] = values.range;
                const params = {
                    ...values,
                    start_date: moment(start_date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                    end_date: moment(end_date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                    name: selected
                };
                delete params.range;

                const args = existing ? [contractor, existing.id, params] : [contractor, params];
                fn(...args).then(() => {
                    form.resetFields();
                    this.setState({ modalOpen: false, confirmLoading: false });
                });
            });
        };
        const saveFormRef = ref => {
            this.formRef = ref;
        };

        const description = item => {
            const exists = qualifications.find(i => i.name === item.name);
            if (!exists) return "Valid Through -";

            const {start_date, end_date} = exists;
            const start = moment(start_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
            const end = moment(end_date, 'YYYY-MM-DD').format('DD/MM/YYYY');

            return `Valid Through: ${start} - ${end}`;
        };
        const handleUpload = (qualification) => ({
            data,
            file,
            filename,
            onError,
            onProgress,
            onSuccess
        }) => {
            const formData = new FormData();
            formData.append(filename, file);

            return uploadQualificationDocument(contractor, qualification.id, formData).then(() => {
                const {uploadError} = this.props.qualifications.data.find(d => d.id === qualification.id);
                if (!uploadError) {
                    file.status = 'done';
                    return onSuccess(file);
                }

                const {res: {errors, message}} = uploadError;
                file.status = 'error';
                file.response = message;
                return onError(file);
            });
        };
        const onDelete = (qualification) => (doc) => {
            return deleteQualificationDocument(contractor, qualification.id, doc.uid);
        };
        const actions = (item) => {
            const a = [<a onClick={openModal(item.name)}><Icon type="edit"/> edit</a>];
            const exists = qualifications.find(i => i.name === item.name);
            if (exists) {
                a.push(
                    <Document
                        documents={exists.documents}
                        onUpload={handleUpload(exists)}
                        onRemove={onDelete(exists)}
                        generateUrl={(uid) => `/api/contractor/${contractor}/qualification/${exists.id}/documents/${uid}`}
                    />
                )
            }
            return a;
        };
        return (
            <Card title="Business Qualifications" loading={isFetching} bordered={false}>
                <List
                    itemLayout="vertical"
                    dataSource={availableOptions}
                    renderItem={item => (
                        <List.Item actions={actions(item)}>
                            <List.Item.Meta
                                title={item.name}
                                description={description(item)}
                            />
                        </List.Item>
                    )}
                />
                <WrappedForm
                    title={selected}
                    wrappedComponentRef={saveFormRef}
                    visible={modalOpen}
                    onCancel={handleCancel}
                    onCreate={handleOk}
                    confirmLoading={confirmLoading}
                    record={qualifications.find(i => i.name === selected)}
                />
            </Card>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        contractor: state.me.contractor_id,
        preferences: state.contractor.preferences,
        qualifications: state.contractor.qualifications
    }
};

export default connect(mapStateToProps, {
    fetchContractorPreferences,
    fetchContractorQualifications,
    storeContractorQualification,
    updateContractorQualification,
    uploadQualificationDocument,
    deleteQualificationDocument
})(BusinessQualification);


// WEBPACK FOOTER //
// ./resources/assets/js/components/contractor/BusinessQualification.js